import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { homeSections } from '../../.temp/asset';
import translate from '../../i18n/translate';
import ejs from 'ejs';
import _ from 'lodash';
class HomePage extends Component {
    constructor(props) {
        super(props);
    }

    generateSection(section, index) {
        let htmlPartial = section.htmlPartialPage;
        const key = section.title || ('scection' + index);
        if (htmlPartial) {
            if (section.intlResources) {
                htmlPartial = ejs.render(htmlPartial, section.intlResources);
            }
            return (
                <div key={key} dangerouslySetInnerHTML={{__html:htmlPartial}} />
            );
        } else {
            const wrapperClass = (index % 2 === 0 ? "feature-wrapper" : "feature-wrapper-alt");
            return (<scection key={key} className="layer">
                <div className={wrapperClass}>
                    <div className="feature-description">
                        <h2>{section.title}</h2>
                        <p className="lead">{section.description}</p>
                    </div>
                    <div className="feature-img">
                        <div>
                            <img src={section.icon}/>
                        </div>
                    </div>
                </div>
            </scection>);
        }
    }

    render() {
        const self = this;
        let { sections } = self.props;
        var len = sections.length;
        var i;
        for (i = 0; i < len; i++) {
            sections[i] = _.assign(sections[i], self.props.strings.homeSections[i]);
        }
        if (!sections) {
            return <h1><i>Loading home page...</i></h1>;
        }
        let wrapperClass;
        return (
            <div className="site-content">
                {sections.map(function(section, index) {
                    return self.generateSection(section,index);
                })}
            </div>
        );
    }
}

HomePage.PropTypes = {
    sections: PropTypes.array.isRequired
};

HomePage.defaultProps = {
    sections: [],
    strings: {}
};

const stateToProps = state => ({
    sections: homeSections
});

const decorators = _.flow([
    connect(stateToProps),
    translate('HomePage')
]);

export default decorators(HomePage);

// function mapStateToProps(state) {
//     return {
//         sections: homeSections
//     };
// }
// export default connect(
//     mapStateToProps
// )(HomePage);



// WEBPACK FOOTER //
// ./client/containers/HomePage.js